export const SET_LOADING_V2 = 'SET_LOADING_VIEW_V2';

export const setLoadingApp = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_LOADING_V2,
      payload
    });
  };
};

export const SET_COLLAPSE_MENU_V2 = 'SET_COLLAPSE_MENU_VIEW_V2';

export const setCollapseItems = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_COLLAPSE_MENU_V2,
      payload
    });
  };
};

// ** Get all Data Lease Combined
export const findNestJSLease = (
  token,
  status = '',
  idUser = '',
  setLoad,
  userData = null,
  filterLimit = null
) => {
  return async (dispatch) => {
    dispatch(setLoadingApp(true));

    const newStatus = status ? `status=${status}` : '';
    const newIdUser = idUser ? `id_auth0_user=${idUser}` : '';
    const newLimit = filterLimit ? `limit=${filterLimit}` : '';
    const exclude = userData.role === 'Dev' ? '' : 'authorRoleExclude[]=Dev';
    
    const urlLeases = `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters?page=1${newStatus ? `&${newStatus}` : '' }${newIdUser ? `&${newIdUser}` : ''}${exclude ? `&${exclude}` : ''}${newLimit ? `&${newLimit}` : ''}`;

    try {
      const response = await fetch(urlLeases, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const resultJSON = await response.json();
      setLoad(false);
      dispatch({
        type: 'FIND_NEST_LEASES',
        data: resultJSON.items
      });
    } catch (error) {
      console.error('Error while fetching quotations:', error);
    } finally {
      dispatch(setLoadingApp(false));
    }
  };
};

export const updateRowJSLease = (response) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_NEST_LEASES',
      data: response
    });
  };
}

export const newRowJSLease = (response) => {
  return (dispatch) => {
    dispatch({
      type: 'NEW_UPDATE_NEST_LEASES',
      data: response
    });
  };
}

export const getNestJSLease = (
  token,
  id,
  setShowPreview = () => {},
  setQuotation = () => {},
  setLoad = () => {},
  setAssetsLoad = () => {}
) => {
  if (!id) {
    return false;
  }
  return (dispatch) => {
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async (response) => {
      const resultJSON = await response.json();
      dispatch({
        type: 'GET_NEST_LEASES',
        data: resultJSON
      });
      setLoad(false);
      setQuotation(resultJSON);
      setAssetsLoad(false);
      setShowPreview(true);
    });
  };
};

export const getNestJSSingleQuotations = (token, id) => {
  if (!id) {
    return false;
  }

  return async (dispatch) => {
    dispatch(setLoadingApp(true));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      const resultJSON = await response.json();
      
      dispatch({
        type: 'GET_NEST_LEASES',
        data: resultJSON
      });
    } catch (error) {
      console.log('error', error)
    } finally {
      dispatch(setLoadingApp(false));
    }
  };
};

export const getNestJSLocalQuotations = (data) => {
  if (!data) {
    return false;
  }

  return async (dispatch) => {
    dispatch(setLoadingApp(true));
    dispatch({
      type: 'GET_NEST_LEASES',
      data: data
    });
    dispatch(setLoadingApp(false));
  };
};

export const GET_ASSUMP_LEASE = '[LEASE_DETAIL]_GET_ASSUMP_LEASE';

export const getNestJSLeaseLease = (
  token,
  id,
  setShowPreview = () => {},
  setQuotation = () => {},
  setLoad = () => {},
  setAssetsLoad = () => {}
) => {
  if (!id) {
    return false;
  }
  return (dispatch) => {
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async (response) => {
      const resultJSON = await response.json();
      const payload = resultJSON || {};
      const type = GET_ASSUMP_LEASE
      dispatch({ type, payload });
      setLoad(false);
      setQuotation(resultJSON);
      setAssetsLoad(false);
      setShowPreview(true);
    });
  };
};

export const getNestJSEmptyQuote = () => {
  return (dispatch) => {
    dispatch({
      type: 'GET_NEST_LEASES',
      data: {}
    });
  };
};

export const getQuotePrint = (data, useStorePreview = () => {}) => {
  return async (dispatch) => {
    useStorePreview(data);
    dispatch({
      type: 'GET_NEST_PRINT_LEASES',
      data
    });
  };
};

export const postNestJSLease = (
  token,
  data,
  useStorePreview,
  setLoad,
  setShowPreview
) => {
  return (dispatch) => {
    if (data._id) {
      delete data._id;
    }
    setLoad(true);
    return fetch(`${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`
      }
    }).then(async (response) => {
      const resultJSON = await response.json();
      useStorePreview(resultJSON);
      setLoad(false);
      dispatch({
        type: 'POST_NEST_LEASES',
        data: resultJSON
      });
      dispatch(
        getNestJSLease(
          token,
          resultJSON._id,
          setShowPreview,
          useStorePreview,
          setLoad
        )
      );
    });
  };
};

export const patchNestJSLease = (
  token,
  id,
  data,
  useStorePreview,
  setLoad,
  setShowPreview,
  toggleModalValid = () => {},
  toggleModalOptions = () => {},
  getQuote = true
) => {
  return (dispatch) => {
    if (setLoad) {
      setLoad(true);
    }
    if (data._id) {
      delete data._id;
    }
    if (data.updatedAt) {
      delete data.updatedAt;
    }
    if (data.createdAt) {
      delete data.createdAt;
    }

    const newData = data;
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
      {
        method: 'PUT',
        body: JSON.stringify(newData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async (response) => {
      const resultJSON = await response.json();
      useStorePreview(response.data);
      if (setLoad) {
      setLoad(false);
      }
      dispatch({
        type: 'PATCH_NEST_LEASES',
        data: resultJSON
      });
      if (getQuote) {
        dispatch(
          getNestJSLease(
            token,
            id,
            setShowPreview,
            useStorePreview,
            setLoad
          )
        );
      }
      if (toggleModalValid) {
        toggleModalValid();
      }
      if (toggleModalOptions) {
        toggleModalOptions();
      }
      
    });
  };
};

export const patchNestJSLeaseStatus = (
  token,
  id,
  data,
  setLoad,
  history
) => {
  return (dispatch) => {
    setLoad(true);
    if (data._id) {
      delete data._id;
    }
    if (data.updatedAt) {
      delete data.updatedAt;
    }
    if (data.createdAt) {
      delete data.createdAt;
    }

    const newData = data;
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
      {
        method: 'PUT',
        body: JSON.stringify(newData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async (response) => {
      const resultJSON = await response.json();
      setLoad(false);
      dispatch({
        type: 'PATCH_NEST_LEASES',
        data: resultJSON
      });
      if (history) history.push('/onboarding/leaseparameters/list');
    });
  };
};

export const deleteNestJSLease = (token, id, refreshData) => {
  if (!id) {
    return false;
  }
  return (dispatch) => {
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/leaseparameters/${id}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async (response) => {
      // await refreshData();
      dispatch({
        type: 'DELETE_NEST_LEASES',
        id: id
      });
    });
  };
};

export const socketSyncQueueBull = async (
  socket,
  payload,
  setQuotation,
  setLoad
) => {
  if (!payload) {
    return false;
  }

  console.log('Payload Quotation', payload)
  socket.emit('generateQuotation', payload);
};

export const socketSyncAssetsQuotation = async (socket, payload) => {
  if (!payload) {
    return false;
  }
  socket.emit('assetsQuotation', payload);
};

export const socketSyncEditQuotation = async (socket, payload) => {
  if (!payload) {
    return false;
  }

  socket.emit('editQuotation', { idQuotation: payload._id, ...payload });
};

export const socketUpdateQuote = (
  payload,
  setQuotation = () => {},
  setLoad = () => {}
) => {
  if (!payload) {
    return false;
  }
  return (dispatch) => {
    setQuotation(payload);
    setLoad(false);
    dispatch({
      type: 'SYNC_NEST_LEASES',
      data: payload
    });
  };
};

export const getQuoteToLease = ({
  id,
  token,
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
}) => {
  return (dispatch) => {
    return fetch(
      `${process.env.REACT_APP_NESTJS_API}/api/v1/sync-lease-v1/sync/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(async (response) => {
        const resultJSON = await response.json();
        dispatch({
          type: 'SYNC_NEST_QUOTE_LEASE',
          data: resultJSON
        });
        onSuccess(resultJSON);
      })
      .catch((e) => onError(e))
      .finally(() => onFinally());
  };
};

export const getAssets = (
  data,
  value,
  setSelectedMM = () => {},
  setLoad = () => {}
) => {
  if (!data) {
    return false;
  }
  return (dispatch) => {
    setLoad(false);
    setSelectedMM(value);
    dispatch({
      type: 'GET_DATA_ASSETS_LEASES',
      data: data
    });
  };
};

export const getAssetsEmpty = () => {
  return (dispatch) => {
    dispatch({
      type: 'GET_DATA_ASSETS_LEASES',
      data: []
    });
  };
};

export const patchNestJSLeaseAssump = (
  token,
  id,
  data,
  setAssetsLoad,
  newSocket
) => {
  return (dispatch) => {
    setAssetsLoad(true);
    if (data._id) {
      delete data._id;
    }
    if (data.updatedAt) {
      delete data.updatedAt;
    }
    if (data.createdAt) {
      delete data.createdAt;
    }

    const newData = data;
    socketSyncEditQuotation(newSocket, { idQuotation: id, ...newData });
  };
};
